/**
 * @file Use this component to navigate to an empty page. Technical solution making dynamic routing possible.
 * @author Tom Verschoore de la Houssaije
 */
/**
 * Use this component to navigate to an empty page.
 */
var EmptyComponent = /** @class */ (function () {
    /**
     * Constructs a EmptyComponent
     */
    function EmptyComponent() {
        // Does nothing
    }
    return EmptyComponent;
}());
export { EmptyComponent };
